import React, { createContext, useState } from "react";
import { mediaLimit } from "../config/media.config";

interface PaginationState {
    totalPage: number;
    page: number;
    lastIdList: { page: number; lastId: string }[];
}

interface FiltersState {
    selectedStartDate: Date | null;
    selectedEndDate: Date | null;
    selectedUploadBy: string[] | null;
    infographicStates: {
        infographic: boolean;
        noInfographic: boolean;
    };
}

interface PaginationFilterContextType {
    pagination: PaginationState;
    setPagination: React.Dispatch<React.SetStateAction<PaginationState>>;
    filters: FiltersState;
    setFilters: React.Dispatch<React.SetStateAction<FiltersState>>;
    searchTopic: string;
    setSearchTopic: React.Dispatch<React.SetStateAction<string>>;
    lastId: string;
    setLastId: React.Dispatch<React.SetStateAction<string>>;
    isArchived: boolean;
    setIsArchived: React.Dispatch<React.SetStateAction<boolean>>;
    limitItem: number;
    setLimitItem: React.Dispatch<React.SetStateAction<number>>;
}

export const PaginationFilterContext = createContext<PaginationFilterContextType | undefined>(undefined);

export const PaginationFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [pagination, setPagination] = useState({
        totalPage: 0,
        page: 1,
        lastIdList: [{ page: 1, lastId: "" }],
    });

    const [filters, setFilters] = useState({
        selectedStartDate: null as Date | null,
        selectedEndDate: null as Date | null,
        selectedUploadBy: [] as string[] | null,
        infographicStates: {
            infographic: false,
            noInfographic: false,
        }
    });

    const [searchTopic, setSearchTopic] = useState('');
    const [lastId, setLastId] = useState('');
    const [isArchived, setIsArchived] = useState(false);
    const [limitItem, setLimitItem] = useState(mediaLimit);

    return (
        <PaginationFilterContext.Provider
            value={{
                pagination, setPagination,
                filters, setFilters,
                searchTopic, setSearchTopic,
                lastId, setLastId,
                isArchived, setIsArchived,
                limitItem, setLimitItem
            }}
        >
            {children}
        </PaginationFilterContext.Provider>
    );
};
